import React from "react";
import clsx from "clsx";
import { GreaterIcon } from "../../icons";

/**
 * Native select with registration form styling.
 * Chevron uses GreaterIcon + rotate-90 / rotate-270 (same as RDList Filter).
 */
const RegistrationFormSelect = ({
  className,
  onFocus,
  onBlur,
  onChange,
  onKeyDown,
  ...rest
}) => {
  const handleKeyDown = (event) => {
    // Enter on a focused native <select> submits the parent form instead of
    // opening the list, so Tab-then-Enter never selects a provider.
    if (event.key === "Enter" && !event.currentTarget.disabled) {
      event.preventDefault();
      try {
        event.currentTarget.showPicker?.();
      } catch {
        // showPicker can throw; preventing form submit is still required.
      }
    }
    onKeyDown?.(event);
  };

  return (
    <div className="form-select-wrap">
      <select
        {...rest}
        className={clsx("form-input", "form-select", className)}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={handleKeyDown}
      />
      <GreaterIcon
        height={14}
        width={14}
        fill="#5a6b80"
        className="form-select-icon rotate-90"
        aria-hidden
      />
    </div>
  );
};

export default RegistrationFormSelect;
